import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { setAdminAuthToken } from '../jscontrol/apiClient';
import { ADMIN_BRAND } from '../../utils/brandAssets';

const AdminHeader = () => {
  const navigate = useNavigate();

  const handleLogout = (e) => {
    e.preventDefault();
    setAdminAuthToken(null);
    navigate('/');
  };

  return (
    <>
    <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
      <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
        <Link className="navbar-brand brand-logo admin-brand-logo" to="/admin">
          <img src={ADMIN_BRAND.logoIcon} alt="Admin logo" className="admin-brand-logo__icon" />
          <span className="admin-brand-logo__title">{ADMIN_BRAND.logoTitle}</span>
        </Link>
      </div>
      <div className="navbar-menu-wrapper d-flex align-items-stretch">
        <button className="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
          <span className="mdi mdi-menu"></span>
        </button>
        <ul className="navbar-nav navbar-nav-right">
          <li className="nav-item nav-profile dropdown">
            <a className="nav-link dropdown-toggle" id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
              <div className="nav-profile-img">
                <img src="/admin-assets/images/faces/face28.png" alt="user" />
                <span className="availability-status online"></span>
              </div>
              <div className="nav-profile-text">
                <p className="mb-1 text-black">Admin User</p>
              </div>
            </a>
            <div className="dropdown-menu navbar-dropdown dropdown-menu-end p-0 border-0 font-size-sm" aria-labelledby="profileDropdown">
              <div className="p-3 text-center bg-primary">
                <img className="img-avatar img-avatar48 img-avatar-thumb" src="/admin-assets/images/faces/face28.png" alt="" />
              </div>
              <div className="p-2">
                <a
                  className="dropdown-item py-1 d-flex align-items-center justify-content-between"
                  href="/"
                  onClick={handleLogout}
                >
                  <span>Log Out</span>
                  <i className="mdi mdi-logout ms-1"></i>
                </a>
              </div>
            </div>
          </li>
          <li className="nav-item dropdown">
            <a className="nav-link count-indicator dropdown-toggle" id="notificationDropdown" href="#" data-bs-toggle="dropdown">
              <i className="mdi mdi-bell-outline"></i>
              <span className="count-symbol bg-danger"></span>
            </a>
            <div className="dropdown-menu dropdown-menu-end navbar-dropdown preview-list" aria-labelledby="notificationDropdown">
              <h6 className="p-3 mb-0 bg-primary text-white py-4">Notifications</h6>
              <div className="dropdown-divider"></div>
              <a className="dropdown-item preview-item" href="#">
                <div className="preview-thumbnail">
                  <div className="preview-icon bg-success">
                    <i className="mdi mdi-calendar"></i>
                  </div>
                </div>
                <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">
                  <h6 className="preview-subject font-weight-normal mb-1">New Order Received</h6>
                  <p className="text-gray ellipsis mb-0">Just now</p>
                </div>
              </a>
              <div className="dropdown-divider"></div>
              <h6 className="p-3 mb-0 text-center">See all notifications</h6>
            </div>
          </li>
        </ul>
        <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
          <span className="mdi mdi-menu"></span>
        </button>
      </div>
    </nav>
    </>
  );
};

export default AdminHeader;
